import React from 'react';
import { WrapperInnerTable } from './wrapper-inner-table';
export function Wrapper(props) {
    const { backgroundColor, backgroundPosition = 'top center', backgroundRepeat = 'repeat', backgroundSize = 'auto', backgroundUrl, children, controls, cssClass, padding = '20px 0', } = props;
    const background = backgroundUrl
        ? {
            background: getBackground({
                backgroundColor,
                backgroundUrl,
                backgroundSize,
                backgroundRepeat,
                backgroundPosition,
            }),
            // background size, repeat and position has to be seperate since yahoo does not support shorthand background css property
            backgroundPosition: getBackgroundPosition({ backgroundPosition }),
            backgroundRepeat,
            backgroundSize,
            width: '100%',
        }
        : {
            background: backgroundColor,
            width: '100%',
            backgroundColor,
        };
    const attributes = backgroundUrl
        ? {}
        : {
            width: '100%',
            bgcolor: background.backgroundColor,
        };
    return (React.createElement("table", { align: "center", className: cssClass, background: backgroundUrl, border: "0", cellPadding: "0", cellSpacing: "0", role: "presentation", style: { ...background }, ...attributes },
        React.createElement("tbody", null,
            React.createElement("tr", null,
                React.createElement("td", null,
                    controls,
                    React.createElement(WrapperInnerTable, { backgroundColor: backgroundColor, backgroundUrl: backgroundUrl, padding: padding }, children))))));
}
function getBackgroundPosition({ backgroundPosition }) {
    const { x, y } = parseBackgroundPosition({ backgroundPosition });
    return `${x} ${y}`;
}
function parseBackgroundPosition({ backgroundPosition }) {
    const posSplit = backgroundPosition.split(' ');
    if (posSplit.length === 1) {
        const val = posSplit[0];
        // here we must determine if x or y was provided ; other will be center
        if (['top', 'bottom'].includes(val)) {
            return {
                x: 'center',
                y: val,
            };
        }
        return {
            x: val,
            y: 'center',
        };
    }
    if (posSplit.length === 2) {
        // x and y can be put in any order in background-position so we need to determine that based on values
        const val1 = posSplit[0];
        const val2 = posSplit[1];
        if (['top', 'bottom'].includes(val1) ||
            (val1 === 'center' && ['left', 'right'].includes(val2))) {
            return {
                x: val2,
                y: val1,
            };
        }
        return {
            x: val1,
            y: val2,
        };
    }
    // more than 2 values is not supported, let's treat as default value
    return { x: 'center', y: 'top' };
}
function getBackground({ backgroundColor, backgroundUrl, backgroundSize, backgroundRepeat, backgroundPosition, }) {
    return ([
        backgroundColor,
        ...(backgroundUrl
            ? [
                `url('${backgroundUrl}')`,
                getBackgroundPosition({ backgroundPosition }),
                `/ ${backgroundSize}`,
                backgroundRepeat,
            ]
            : []),
    ]
        .filter((_) => _)
        .join(' ') || undefined);
}
//# sourceMappingURL=wrapper.js.map